import React from 'react';
import { Link  } from "react-router-dom";
import { Utils } from '../../../Utils';
import i18n from '../../../i18n/i18n.js';
import { ReactSVG } from "react-svg";

import './Select.css';

class Select extends React.Component {

  parent = null;
  
  constructor(props) {
    super(props);

    this.parent = typeof props.parent != 'undefine' ? props.parent : null;
    this.ws_data = typeof props.ws_data != 'undefine' ? props.ws_data : null;

    this.state = {};
  }

  render() {
    const {formData, formErrors} = this.parent.state;
    const parent = this.parent;
    const ws_data = this.ws_data;

    let label = '';

    if (!!ws_data.label) {
      label =  <label className="field_label" dangerouslySetInnerHTML={{__html: ws_data.label + (ws_data.required ? ' *' : '')}}></label> ;
    }

    const conditionalProps = {};

    return <div className="row">
      <div className={`field text ${ws_data.fieldname} ${formErrors[ws_data.fieldname] !== '' ? "error" : ""}`}>

        {label}

        <div className="select">
          <select 
            defaultValue={ws_data.value} 
            onChange={(e) => parent.handle_change(e, ws_data.fieldname)} 
            {...conditionalProps} 
          >
            {ws_data.values ? Object.keys(ws_data.values).map((index) => 
              <option key={index} value={index}>{ws_data.values[index].trim()}</option>
            ) : ''}
          </select> 
          <ReactSVG src="assets/images/arrow_down.svg" />
        </div>

        {(formErrors[ws_data.fieldname].length) 
          ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors[ws_data.fieldname]}}></div> : '' }
      </div>
    </div>; 
  }
};

export default Select;
